import { Button } from 'antd';

import handScanning from 'assets/images/hand-phone.svg';

import styles from './styles.module.css';

type RequestPermissionProps = {
  cameraId: string | null;
  requestPermission: () => void;
};

const RequestPermission = ({ cameraId, requestPermission }: RequestPermissionProps) => {
  if (cameraId) {
    return null;
  }

  return (
    <div className={styles.container}>
      <img src={handScanning} alt='Hand scanning QR Code' />
      <Button onClick={requestPermission} type='primary' className={`${styles.button} ${styles.primaryBlue}`}>
        <span className={styles.text}>Autorizar Acesso a Câmera</span>
      </Button>
    </div>
  );
};

export default RequestPermission;
